<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">{{this.$route.meta.title}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(index)="data">
          {{ data.index +1}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="10" lg="10">
        <b-card >
          <div slot="header">Project Job Type - Add/Edit Form 
          </div>
                <!-- <b-input-group >
                    <b-input-group-prepend><label>Job Type Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.job_name" :state="!$v.frmdata.job_name.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.uraian" :state="!$v.frmdata.uraian.$error" ></b-form-input>
                </b-input-group> -->
              <b-row>
                <b-col v-for="field in formfields" :key="field.key" :cols="field.col">
                  <b-input-group >
                      <b-input-group-prepend><label>{{field.label}}</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata[field.key]"
                      :state="field.validation?!$v.frmdata[field.key].$error:true"
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>

        </b-card>
        </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        model_name: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      frmdata:{
        model_name:'',ar_dueNo:'',ar_dueNm:'',arnot_dueNo:'',arnot_dueNm:'',UCI_No:'',
        UCI_Nm:'',ECI_No:'',ECI_Nm:'',AR_NA_No:'',AR_NA_Nm:'',UCI_NA_No:'',UCI_NA_Nm:'',
        OTH_ALW_No:'',OTH_ALW_Nm:'',rev_accNo:'',rev_accNm:'',rev_dendaNo:'',rev_dendaNm:'',
        OTH_INCOME_No:'',OTH_INCOME_Nm:'',Hutang_Prepaid_PAB_No:'',Hutang_Prepaid_PAB_Nm:'',tolerance_amount:0, 
        grace_periode:0},
      tblData: {
        tablename:'modelpinjaman',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'model_name',
        sortDesc: false
      },
    };
  },
  computed: {
    formfields(){
      const fields=[
          {
              key: "model_name",
              label: "Model Pinjaman",
              col:12,
              validation:true
          },
          {
              key: "ar_dueNo",
              label: "AR Due COA",
              col:6
          },
          {
              key: "ar_dueNm",
              label: "AR Due COA Name",
              col:6
          },
          {
              key: "arnot_dueNo",
              label: "AR Undue COA",
              col:6
          },
          {
              key: "arnot_dueNm",
              label: "AR Undue COA Name",
              col:6
          },
          {
              key: "UCI_No",
              label: "UCI COA",
              col:6
          },
          {
              key: "UCI_Nm",
              label: "UCI COA Name",
              col:6
          },
          {
              key: "ECI_No",
              label: "ECI COA",
              col:6
          },
          {
              key: "ECI_Nm",
              label: "ECI COA Name",
              col:6
          },
          {
              key: "AR_NA_No",
              label: "AR NA COA",
              col:6
          },
          {
              key: "AR_NA_Nm",
              label: "AR NA COA Name",
              col:6
          },
          {
              key: "UCI_NA_No",
              label: "UCI NA COA",
              col:6
          },
          {
              key: "UCI_NA_Nm",
              label: "UCI NA COA Name",
              col:6
          },
          {
              key: "OTH_ALW_No",
              label: "OTH ALW COA",
              col:6
          },
          {
              key: "OTH_ALW_Nm",
              label: "OTH ALW COA Name",
              col:6
          },
          {
              key: "rev_accNo",
              label: "Revenue COA",
              col:6
          },
          {
              key: "rev_accNm",
              label: "Revenue COA Name",
              col:6
          },
          {
              key: "rev_dendaNo",
              label: "Revenue Denda COA",
              col:6
          },
          {
              key: "rev_dendaNm",
              label: "Revenue Denda COA Name",
              col:6
          },
          {
              key: "OTH_INCOME_No",
              label: "OTH INCOME COA",
              col:6
          },
          {
              key: "OTH_INCOME_Nm",
              label: "OTH INCOME COA Name",
              col:6
          },
          {
              key: "Hutang_Prepaid_PAB_No",
              label: "Hutang Prepaid PAB COA",
              col:6
          },
          {
              key: "Hutang_Prepaid_PAB_Nm",
              label: "Hutang Prepaid PAB Name",
              col:6
          },   
          {
              key: "grace_periode",
              label: "Grace Periode (Days)",
              col:6
          },
          {
              key: "tolerance_amount",
              label: "Tolerance Amount",
              col:6
          }        
        ];
      return fields;
    },
    tblFields(){
      const fields=[
          {
            key: "index",
            label: "No.",
          },
          {
              key: "model_name",
              label: "Model Pinjaman",
              thStyle: "min-width:150px",
          },
          {
              key: "ar_dueNo",
              label: "AR Due Coa",
              thStyle: "min-width:150px",
          },
          {
              key: "ar_dueNm",
              label: "AR Due Coa Name",
              thStyle: "min-width:150px",
          },
          {
              key: "arnot_dueNo",
              label: "AR Undue Coa",
              thStyle: "min-width:150px",
          },
          {
              key: "arnot_dueNm",
              label: "AR Undue Coa Name",
              thStyle: "min-width:150px",
          },
          {
              key: "UCI_No",
              label: "UCI Coa",
              thStyle: "min-width:150px",
          },
          {
              key: "UCI_Nm",
              label: "UCI Coa Name",
              thStyle: "min-width:150px",
          },
          {
              key: "ECI_No",
              label: "ECI COA",
              thStyle: "min-width:150px",
          },
          {
              key: "ECI_Nm",
              label: "ECI COA Name",
              thStyle: "min-width:150px",
          },
          {
              key: "AR_NA_No",
              label: "AR NA COA",
              thStyle: "min-width:150px",
          },
          {
              key: "AR_NA_Nm",
              label: "AR NA COA Name",
              thStyle: "min-width:150px",
          },
          {
              key: "UCI_NA_No",
              label: "UCI NA COA",
              thStyle: "min-width:150px",
          },
          {
              key: "UCI_NA_Nm",
              label: "UCI NA COA Name",
              thStyle: "min-width:150px",
          },
          {
              key: "OTH_ALW_No",
              label: "OTH ALW COA",
              thStyle: "min-width:150px",
          },
          {
              key: "OTH_ALW_Nm",
              label: "OTH ALW COA Name",
              thStyle: "min-width:150px",
          },
          {
              key: "rev_accNo",
              label: "Revenue COA",
              thStyle: "min-width:150px",
          },
          {
              key: "rev_accNm",
              label: "Revenue COA Name",
              thStyle: "min-width:150px",
          },
          {
              key: "rev_dendaNo",
              label: "Revenue Denda COA",
              thStyle: "min-width:150px",
          },
          {
              key: "rev_dendaNm",
              label: "Revenue Denda COA Name",
              thStyle: "min-width:150px",
          },
          {
              key: "OTH_INCOME_No",
              label: "OTH INCOME COA",
              thStyle: "min-width:150px",
          },
          {
              key: "OTH_INCOME_Nm",
              label: "OTH INCOME COA Name",
              thStyle: "min-width:150px",
          },
          {
              key: "Hutang_Prepaid_PAB_No",
              label: "Hutang Prepaid PAB COA",
              thStyle: "min-width:150px",
          },
          {
              key: "Hutang_Prepaid_PAB_Nm",
              label: "Hutang Prepaid PAB Name",
              thStyle: "min-width:150px",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.id;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', 'ERROR MESSAGE');
        } else {
            try {
              let dataset={};
              for (const key in this.frmdata) {
                dataset[key]=this.frmdata[key]
              }
              delete dataset._rowVariant;
              if (this.frmdata.model_id) {
                await crud.update(
                     {tablename:'modelpinjaman', 
                     key:this.frmdata.model_id, 
                     data:dataset});
              } else {
                await crud.insert(
                  { tablename:'modelpinjaman',                      
                     data:dataset
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'projecttype', key:this.model.id});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
